import { initAnalytics, readAnalyticsOptOut, shouldEnableAnalytics } from "@mountayaapp/analytics";

import { POSTHOG_HOST, POSTHOG_PROJECT_TOKEN, POSTHOG_UI_HOST } from "../config/endpoints";

/**
 * startAnalytics loads and initializes PostHog for the documentation site,
 * session replay included. It shares the application's capture and masking
 * policy through @mountayaapp/analytics, so the two properties cannot drift on
 * what a pageview is or on what a replay is allowed to record.
 *
 * The docs ship with no project token by default, which is what leaves analytics
 * off for a local or preview build: only a deploy that supplies one reports.
 * There is no e2e suite here, so that arm of the gate is constant. The opt-out is
 * read rather than passed as false: nobody signs in here, so this site can never
 * set it, but reading it is what makes the exclusion hold if the docs are ever
 * served from the application's own origin.
 */
export const startAnalytics = (): void => {
  const enabled = shouldEnableAnalytics({
    isE2E: false,
    isOptedOut: readAnalyticsOptOut(),
    mode: import.meta.env.MODE,
    pathname: window.location.pathname,
    token: POSTHOG_PROJECT_TOKEN,
  });

  if (!enabled) {
    return;
  }

  void initAnalytics({
    apiHost: POSTHOG_HOST,
    replay: true,
    token: POSTHOG_PROJECT_TOKEN,
    uiHost: POSTHOG_UI_HOST,
  });
};
